<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!Post.isForm" flat class="pa-2 text-no-wrap">
        <h2 class="pa-2">
          {{ $t(`table.filter`) }}
        </h2>
        <v-layout wrap align-center>
          <v-col cols :sm="3" class="pa-2">
            <v-text-field
              :label="`${$t('table.search')} ${$t('table.post')} ID`"
              dense
              hide-details
              v-model="filter.postId"
              @keydown.enter="_fnSearch()"
            />
          </v-col>
          <v-col cols :sm="3" class="pa-2">
            <v-text-field
              :label="`${$t('table.search')} ${$t('table.user')} ID`"
              dense
              hide-details
              v-model="filter.userId"
              @keydown.enter="_fnSearch()"
            />
          </v-col>
          <v-col cols :sm="3" class="pa-2">
            <v-text-field
              :label="$t(`table.search`) + ' LomoId'"
              dense
              hide-details
              v-model="filter.lomoId"
              @keydown.enter="_fnSearch()"
            />
          </v-col>
          <v-col cols :sm="3" class="pa-2">
            <v-typePost v-model="filter.isVideo" @change="_fnSearch()" />
          </v-col>
        </v-layout>
        <v-data-table
          dense
          must-sort
          fixed-header
          item-key="id"
          :items="Post.list"
          :options.sync="pagings"
          :headers="cTableHeaders"
          :server-items-length="Post.total"
          :items-per-page="Post.filter.limit"
          :footer-props="{ itemsPerPageOptions: Post.itemPages }"
          :item-class="(e) => (id == e.id ? 'primary lighten-5' : '')"
        >
          <template v-slot:top>
            <v-layout px-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.post") }}</h2>
                <v-spacer />
                <div class="mb-3" :style="{ width: '250px' }">
                  <v-text-field
                    dense
                    single-line
                    hide-details
                    v-model="Post.search"
                    @keydown.enter="_fnSearch()"
                    :placeholder="$t(`table.search`)"
                  />
                </div>
              </v-layout>
            </v-layout>
          </template>
          <template #[`item.action`]="{ item }">
            <v-btnc
              color="warning"
              icon="mdi-pencil"
              @click="
                fnCallUpdateView({ model, item: item });
                _fnLoadData();
              "
              v-if="fnCheckMission(Session, [{ m: POST, p: APPROVE }])"
            />
          </template>
          <template #[`item._id`]="{ item }">
            {{ "LomoId: " + item.extraSearch.lomoId }}<br />
            {{ "PostId: " + item.id }}<br />
            {{ "UserId: " + item.user.id }}<br />
          </template>
          <template #[`item.image`]="{ item }">
            <v-upload
              :size="30"
              class="my-1"
              :images="
                item.images.map((e) => (e.type == 'video' ? e.thumb : e.link))
              "
              :videoLink="
                item.images.length && item.images[0].type == 'video'
                  ? item.images[0].link
                  : ''
              "
              :readonly="true"
            />
          </template>
          <template #[`item.user`]="{ item }">
            {{ item.user.name }}
          </template>
          <template #[`item.isReferral`]="{ item }">
            <span :class="item.isReferral ? 'success--text' : 'error--text'">
              {{ item.isReferral ? "Yes" : "No" }}
            </span>
          </template>
          <template #[`item.status`]="{ item }">
            <span
              v-if="item.status"
              :class="
                item.status.id == '5ff3d93b89e3051a47e7cfe7'
                  ? 'success--text'
                  : item.status.id == '5ff3d93b89e3051a47e7cfe6'
                  ? 'error--text'
                  : 'info--text'
              "
            >
              {{ item.status.name }}
            </span>
          </template>
          <template #[`item.createdAt`]="{ item }">
            {{ item.createdAt | mDateTime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0"><v-dialog /></v-col>
  </v-layout>
</template>

<script>
import Dialog from "./dialog.vue";

export default {
  components: {
    "v-dialog": Dialog,
  },
  data() {
    return {
      id: "",
      model: "Post",
      pagings: {},
      filter: {
        postId: "",
        userId: "",
        lomoId: "",
      },
    };
  },
  computed: {
    cTableHeaders() {
      let table = [
        {
          text: this.$t(`table.action`),
          sortable: false,
          value: "action",
          width: "10px",
        },
        {
          text: this.$t(`table.id`),
          value: "_id",
          width: "10px",
        },
        {
          text: this.$t(`table.image`),
          value: "image",
          width: "10px",
        },
        {
          text: this.$t(`table.name`),
          value: "user",
        },
        {
          text: this.$t(`table.isReferral`),
          value: "isReferral",
          width: "10px",
        },
        {
          text: this.$t(`table.favorite`),
          value: "numberOfFavorite",
          width: "10px",
        },
        {
          text: this.$t(`table.comment`),
          value: "numberOfComment",
          width: "10px",
        },
        {
          text: this.$t(`table.status`),
          value: "status",
          width: "10px",
        },
        {
          text: this.$t(`table.createdAt`),
          value: "createdAt",
          width: "10px",
        },
        {
          text: this.$t(`table.content`),
          value: "content",
          width: "10px",
        },
      ];
      return table;
    },
  },
  watch: {
    "Post.isRefresh": function (val) {
      if (val) {
        this._fnCallListView();
      }
    },
    pagings: function (val) {
      const { itemsPerPage, page, sortBy, sortDesc } = val;
      this[this.model].filter.limit = itemsPerPage;
      this[this.model].filter.page = page;
      if (sortBy.length) {
        this[this.model].filter.sort = `${sortBy[0]}:${sortDesc[0] ? -1 : 1}`;
      }
      this._fnCallListView();
    },
  },
  methods: {
    _fnLoadData() {
      if (this[this.model].isCreate) {
        this[this.model].obj = {};
      } else if (this[this.model].isUpdate) {
        this.id = this[this.model].obj.id;
        this[this.model].obj = {
          ...this[this.model].obj,
          status: this[this.model].obj.status
            ? this[this.model].obj.status.id
            : "",
        };
      }
    },
    _fnCallListView() {
      delete this[this.model].filter._id;
      if (this.filter.postId) {
        this[this.model].filter._id = this.filter.postId;
      }
      delete this[this.model].filter.lomoId;
      if (this.filter.lomoId) {
        this[this.model].filter.lomoId = this.filter.lomoId;
      }
      delete this[this.model].filter.user;
      if (this.filter.userId) {
        this[this.model].filter.user = this.filter.userId;
      }
      delete this[this.model].filter.$text;
      if (this[this.model].search) {
        this[this.model].filter.$text = this[this.model].search;
      }
      delete this[this.model].filter.isVideo;
      if (this.filter.isVideo) {
        this[this.model].filter.isVideo = this.filter.isVideo == 2;
      }
      this.fnCallListView({
        url: "/v1/admin/post",
        model: this.model,
      });
    },
    _fnSearch() {
      this._fnCallListView();
    },
  },
};
</script>
